module.exports = __webpack_public_path__ + "img/teamImg20.7732a36c.jpg";